export enum VariableType {
  MONEY = 'Money',
  TIME = 'Time',
}
